<template>
    <div>
        <form id="documents" enctype="multipart/form-data">
            <div class="container p-3 pt-5 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('pos.documents') }}
                    </div>
                    <kt-row>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="statute_pages_img">
                                        {{ $t('pos.document.statute_pages') }}
                                    </kt-form-label>
                                    <kt-form-label for="statute_pages_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processStatuteFile($event)"
                                            type="file"
                                            id="statute_pages_img"
                                            name="statute_pages_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                            multiple
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" xs="12"
                                    v-for="(image, index) in form_data.images_url.statute_pages_img" :key="index">
                                <i v-if="form_data.images_url.statute_pages_img[index]"
                                   v-on:click="deleteStatutePages(index)" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e;margin-top: 15px;margin-right: 15px"></i>
                                 <kt-img-magnifier class="mb-4" v-if="form_data.images_url.statute_pages_img[index]"
                                     :src="image"
                                     :alt="image.alt"
                                   ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="last_newspaper_img_introduce_sh">
                                        {{ $t('pos.document.last_newspaper_img_introduce_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="last_newspaper_img_introduce_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="last_newspaper_img_introduce_sh"
                                            name="last_newspaper_img_introduce_sh"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.last_newspaper_img_introduce_sh"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('last_newspaper_img_introduce_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.last_newspaper_img_introduce_sh">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.last_newspaper_img_introduce_sh"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_certificate_first_page_of_first_sh">
                                        {{ $t('pos.document.birth_certificate_first_page_of_first_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_first_page_of_first_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="birth_certificate_first_page_of_first_sh"
                                            name="birth_certificate_first_page_of_first_sh"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.birth_certificate_first_page_of_first_sh"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_first_page_of_first_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.birth_certificate_first_page_of_first_sh">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.birth_certificate_first_page_of_first_sh"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_certificate_first_page_of_second_sh">
                                        {{ $t('pos.document.birth_certificate_first_page_of_second_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_first_page_of_second_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="birth_certificate_first_page_of_second_sh"
                                            name="birth_certificate_first_page_of_second_sh"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.birth_certificate_first_page_of_second_sh"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_first_page_of_second_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.birth_certificate_first_page_of_second_sh">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.birth_certificate_first_page_of_second_sh"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card_of_first_sh">
                                        {{ $t('pos.document.national_card_of_first_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_of_first_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="national_card_of_first_sh"
                                            name="national_card_of_first_sh"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.national_card_of_first_sh"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_of_first_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.national_card_of_first_sh">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.national_card_of_first_sh"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card_of_second_sh">
                                        {{ $t('pos.document.national_card_of_second_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_of_second_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="national_card_of_second_sh"
                                            name="national_card_of_second_sh"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.national_card_of_second_sh"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_of_second_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.national_card_of_second_sh">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.national_card_of_second_sh"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="!form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card_img">
                                        {{ $t('pos.document.national_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="national_card_img"
                                            name="national_card_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.national_card_img"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.national_card_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.national_card_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="!form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_certificate_card_img">
                                        {{ $t('pos.document.birth_certificate_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="birth_certificate_card_img"
                                            name="birth_certificate_card_img"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.birth_certificate_card_img"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_card_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.birth_certificate_card_img">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.birth_certificate_card_img"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="delegation_of_authority_national_card">
                                        {{ $t('pos.document.delegation_of_authority_national_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="delegation_of_authority_national_card"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="delegation_of_authority_national_card"
                                            name="delegation_of_authority_national_card"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.delegation_of_authority_national_card"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('delegation_of_authority_national_card')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.delegation_of_authority_national_card">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.delegation_of_authority_national_card"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="card_acceptance_contract">
                                        {{ $t('pos.document.card_acceptance_contract') }}
                                    </kt-form-label>
                                    <kt-form-label for="card_acceptance_contract"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processCardAcceptanceContractFile($event)"
                                            type="file"
                                            id="card_acceptance_contract"
                                            name="card_acceptance_contract"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                            multiple
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" xs="12"
                                    v-for="(image, index) in form_data.images_url.card_acceptance_contract" :key="index">
                                <i v-if="form_data.images_url.card_acceptance_contract[index]"
                                   v-on:click="deleteFileCardAcceptance(index)" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e;margin-top: 15px;"></i>
                                 <kt-img-magnifier class="mb-4" v-if="form_data.images_url.card_acceptance_contract[index]"
                                     :src="image"
                                     :alt="image.alt"
                                     ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="iban_certificate">
                                        {{ $t('pos.document.iban_certificate') }}
                                    </kt-form-label>
                                    <kt-form-label for="iban_certificate"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="iban_certificate"
                                            name="iban_certificate"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.iban_certificate"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('iban_certificate')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.iban_certificate">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.iban_certificate"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="change_iban_form">
                                        {{ $t('pos.document.change_iban_form') }}
                                    </kt-form-label>
                                    <kt-form-label for="change_iban_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="change_iban_form"
                                            name="change_iban_form"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.change_iban_form"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('change_iban_form')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.change_iban_form">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.change_iban_form"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="deposit_receipt">
                                        {{ $t('pos.document.deposit_receipt') }}
                                    </kt-form-label>
                                    <kt-form-label for="deposit_receipt"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="deposit_receipt"
                                            name="deposit_receipt"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.deposit_receipt"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('deposit_receipt')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.deposit_receipt">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.deposit_receipt"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="delegation_of_authority_form">
                                        {{ $t('pos.document.delegation_of_authority_form') }}
                                    </kt-form-label>
                                    <kt-form-label for="delegation_of_authority_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="delegation_of_authority_form"
                                            name="delegation_of_authority_form"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.delegation_of_authority_form"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('delegation_of_authority_form')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.delegation_of_authority_form">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.delegation_of_authority_form"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-show="form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="amayesh_card">
                                        {{ $t('pos.document.amayesh_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="amayesh_card"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input
                                            @change="processFile($event)"
                                            type="file"
                                            id="amayesh_card"
                                            name="amayesh_card"
                                            class="custom-file-upload"
                                            accept=".jpg,.jpeg,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="form_data.images_url.amayesh_card"
                                 style="position:relative;right: 67%;top:1%;"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('amayesh_card')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="form_data.images_url.amayesh_card">
                                 <kt-img-magnifier class="mb-4"
                                        :src="form_data.images_url.amayesh_card"
                                 ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>

                    </kt-row>
                </kt-form-section>
            </div>
        </form>
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {customerType} from '@/constants/posNovin'
import Span from "../../../../components/elements/span";
import Input from "../../../../components/elements/input";


export default {
    data() {
        return {
            customerType
        }
    },
    props: {
        form_data: {
            type :Object
        } ,
    },
    methods: {
        processFile(e) {
            const name = e.target.name;
            let file = e.target.files[0];
            let size_validation = this.validateSize(file)
            let format_validation = this.validateFormat(file)
            if (size_validation != false && format_validation == true ) {
                this.form_data.images_url[name] = URL.createObjectURL(file);
                this.form_data[name] = file
            }
        },
        processCardAcceptanceContractFile(e) {
            this.form_data.images_url.card_acceptance_contract = []
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                let size_validation = this.validateSize(file)
                let format_validation = this.validateFormat(file)
                if (size_validation != false && format_validation == true ) {
                    this.form_data.images_url.card_acceptance_contract[i] = URL.createObjectURL(file);
                    this.form_data.card_acceptance_contract[i] = file;
                }
            }
        },
        processStatuteFile(e) {
            this.form_data.images_url.statute_pages_img = []
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                let size_validation = this.validateSize(file)
                let format_validation = this.validateFormat(file)
                if (size_validation != false && format_validation == true ) {
                    this.form_data.images_url.statute_pages_img[i] = URL.createObjectURL(file);
                    this.form_data.statute_pages_img[i] = file;
                }
            }
        },
        deleteFile(name) {
            this.form_data.images_url[name] = '';
            this.form_data[name] = ''
        },
        deleteFileCardAcceptance(index) {
            this.$set(this.form_data.images_url.card_acceptance_contract, [index], '');
            this.form_data.card_acceptance_contract[index] = ''
        },
        deleteStatutePages(index) {
            this.$set(this.form_data.images_url.statute_pages_img, [index], '');
            this.form_data.statute_pages_img[index] = ''
        },
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });

            }, 500);
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 5) {
                return this.toastr.error(i18n.t('authenticate.hint.sixth'))
            }
            return true
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }
            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    break;
                default:
                    return this.toastr.error(i18n.t('authenticate.input_format_err'))
            }
            return true
        },
    },
    mounted() {
        this.afterDispatch()
    },
    computed: {}
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}
.modal .modal-content .modal-header .close:before {
    content: ""!important;
}
.modal .modal-content .modal-body .w-100 {
    max-height: 2000px !important;
}
.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}
</style>